import { Amount, FarePriceResponse, Inclusion, Occupancy } from "@ssc-booking/api-contracts"
import { CruiseCode } from "@ssc-booking/functional-support"
import * as O from "fp-ts/Option"
import { airParams, cruiseDetail, deposit, flightsDetail } from "../../../test-support/common"
import { cruiseCode } from "./cruisecode"

export default FarePriceResponse.build({
    cruiseCode: CruiseCode.buildUnsafe(cruiseCode),
    suiteCategory: "CV",
    occupancy: Occupancy.of(2),
    fareCode: "DoorToDoorV2",
    vsMember: false,
    air: airParams("Economy", "ABQ"),
    suitePayment: deposit(25, 11600, "USD", "2022-11-16"),
    price: {
        total: Amount.of(11600, "USD"),
        originalTotal: O.none,
        paxPrices: [
            {
                number: 1,
                total: Amount.of(5800, "USD"),
                details: {
                    cruise: cruiseDetail(5800, "USD"),
                    promotions: [],
                    flights: flightsDetail(0, "USD", "ABQ", "FLL", "LIS", "Economy", true),
                    others: [],
                },
            },
            {
                number: 2,
                total: Amount.of(5800, "USD"),
                details: {
                    cruise: cruiseDetail(5800, "USD"),
                    promotions: [],
                    flights: flightsDetail(0, "USD", "ABQ", "FLL", "LIS", "Economy", true),
                    others: [],
                },
            },
        ],
        inclusions: Inclusion.listOf(
            "PreDoor2Door",
            "EconomyFlightsWithUpgrade",
            "TransferInternationalAirportToPier",
            "FreeShorex",
            "TransferPierToInternationalAirport",
            "PostDoor2Door",
            "Butler",
            "FoodAndBeverage",
        ),
    },
    availability: "standard",
})
